import moment from "jalali-moment";
import { QRCodeSVG } from "qrcode.react";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BsClockHistory } from "react-icons/bs";
import { GrLocation } from "react-icons/gr";
import { useParams } from "react-router-dom";
import { apiService } from "../../base/service/service";
import config from "../../base/utils/config";
import moneyFormat from "../../base/utils/moneyFormat";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";

export default function QrDetail() {
  const { code } = useParams();
  const [ticket, setTicket] = useState(null);
  const [concert, setConcert] = useState(null);
  const ticketRef = React.createRef();

  useEffect(() => {
    getTicketDetail();
  }, []);
  function getTicketDetail() {
    apiService({
      url: `api/events/user/ticket_detail`,
      params: { code: code },
    }).then((data) => {
      if (data?.success === 1) {
        setTicket(data.ticket);
        setConcert(data.ticket?.event_date?.event);
      }
    });
  }
  function handleTabloDownload() {
    let name = `iranapp-ticket-${ticket.code}.png`;

    var dom = document.getElementById("download");

    var child = null;
    if (dom.hasChildNodes()) {
      child = dom.childNodes[0];
      // dom.removeChild(dom.childNodes[0]);
    }

    const scale = 2;
    const style = {
      transform: "scale(" + scale + ")",
      transformOrigin: "top left",
      width: dom.offsetWidth + "px",
      height: dom.offsetHeight + "px",
    };

    const param = {
      height: dom.offsetHeight * scale,
      width: dom.offsetWidth * scale,
      quality: 1,
      style,
    };

    domtoimage.toJpeg(dom, param).then(function (blob) {
      saveAs(blob, name);
      dom.insertBefore(child, dom.firstChild);
    });
  }
  return (
    <div className="my-3 row mx-auto" style={{ maxWidth: "500px" }}>
      {ticket && concert ? (
        <>
          <div className="col-12 px-0 text-center mb-3">
            <button
              className="btn px-3 py-1 bg-main text-white rounded10 small border-0"
              onClick={() => handleTabloDownload()}
            >
              دانلود
            </button>
          </div>
          <div
            className="rounded10 border border-dark border2 p-2 bg-white"
            ref={ticketRef}
            id="download"
          >
            <div className="row mx-0">
              <div className="col-12 px-0 pb-2 text-center">
                <img
                  alt="logo"
                  height="30"
                  className=""
                  src={
                    require("../../base/assets/images/iran-app-logo.svg")
                      .default
                  }
                />
              </div>
            </div>
            <div className="row mx-0">
              <div className="col-12 px-0 position-relative">
                <img
                  className="rounded10 w-100"
                  alt=""
                  src={require("./banner-salar.svg").default}
                />
              </div>
            </div>
            <div className="row mx-0 p-2 border-bottom border-2 border-white">
              <div className="col-auto px-0 align-self-center">
                <span className="mb-0 fs-7 fw-bolder">کنسرت:</span>
              </div>
              <div className="col-auto px-3 align-self-center">
                <span className="small fw-bolder">{concert.title}</span>
              </div>
            </div>
            <div className="row mx-0 px-2 border-bottom border-2 border-white">
              <div className="col-auto px-0 align-self-center">
                <BsClockHistory className="ms-2" />
                <span className="mb-0 fs-7 fw-bolder">ساعت:</span>
              </div>
              <div className="col-auto px-3 align-self-center">
                <span className="small fw-bolder">
                  {moment(
                    ticket.event_date?.start_time,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format(`HH:mm`)}
                </span>
              </div>
            </div>
            <div className="row mx-0 p-2">
              <div className="col-auto px-0 align-self-center">
                <GrLocation className="my-auto h-100 ms-2" />
                <span className="mb-0 fs-7 fw-bolder ms-2">محل برگزاری:</span>
                <span className="mb-0 fs-7">
                  {concert.venue?.short_address}
                </span>
              </div>

              <div className="row mx-0 mt-1 px-0 align-self-center text-center">
                <div className="col px-0 align-self-center">
                  <img
                    className="rounded10 mb-2"
                    alt=""
                    height={60}
                    src={require("./irana_app.svg").default}
                  />
                </div>
                <div className="col px-0 align-self-center">
                  <img
                    className="rounded10 mb-2"
                    alt=""
                    height={60}
                    src={require("./arka.svg").default}
                  />
                </div>
                <div className="col px-0 align-self-center">
                  <img
                    className="rounded10 mb-2"
                    alt=""
                    height={60}
                    src={require("./siyamad.svg").default}
                  />
                </div>
              </div>
              <div className="row mx-0 mt-1 px-0 align-self-center text-center">
                <div className="col px-0 align-self-center">
                  {/* <a
                    href={
                      window.Android
                        ? window.Android.openPaymentLink(
                            `http://maps.google.com/maps?q=${concert.latitude},${concert.longitude}`
                          )
                        : `http://maps.google.com/maps?q=${concert.latitude},${concert.longitude}`
                    }
                    className="p-0"
                    target="_blank"
                    rel="noreferrer"
                  > */}
                  <img
                    className="rounded10 w-100"
                    alt=""
                    src={require(`./khavaran-map.svg`).default}
                  />
                  {/* </a> */}
                </div>
                <div className="col-5 ps-0 pe-3">
                  <QRCodeSVG value={code} width={"100%"} />
                </div>
              </div>
            </div>
            <div className="row px-1 mx-0 mb-2 text-main">
              <div className="col px-0 fs-7 align-self-center">
                کد ورود شما به سالن:
              </div>
              <div className="col-auto px-0 align-self-center">
                <p className="fs-5 mb-0">{code}</p>
              </div>
            </div>

            <div className="row px-1 mx-0 fs-7 mb-1">
              <div className="col-auto px-0">خریدار:</div>
              <div className="col text-start px-0 fw-bolder">
                {ticket.name} - {ticket.phone}
              </div>
            </div>
            <div className="row px-1 mx-0 fs-7 mb-1">
              <div className="col-auto px-0">قیمت کل:</div>
              <div className="col text-start px-0 fw-bolder">
                {moneyFormat(ticket.total_price, null, "fw-bolder")}
              </div>
            </div>
            <div className="row px-1 mx-0 fs-7 mb-1">
              <div className="col-auto px-0">تاریخ برگزاری:</div>
              <div className="col text-start px-0 fw-bolder">
                {moment(
                  ticket.event_date?.start_time,
                  "YYYY-MM-DD HH:mm:ss"
                ).format(`HH:mm - jMM/jDD`)}
              </div>
            </div>
            <div className="row px-1 mx-0 fs-7 mb-1">
              <div className="col-auto px-0">تاریخ خرید:</div>
              <div className="col text-start px-0 fw-bolder">
                {moment(ticket.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  `HH:mm - jMM/jDD`
                )}
              </div>
            </div>
            <div className="row px-1 mx-0 fs-7 mb-1">
              <div className="col-auto px-0">کد پیگیری تراکنش:</div>
              <div className="col text-start px-0 fw-bolder">
                {Number(ticket.token?.slice(1))}
              </div>
            </div>
            <div className="row mx-0 justify-content-center">
              {ticket.event_ticket_seats?.map((chair, c) => (
                <div className="col-6 p-1">
                  <div className="row mx-0 bg-gray px-0 rounded10 py-1 fs-8">
                    <div className="col-auto ps-0 pe-2 text-center">
                      <p className="mb-0">بخش</p>
                      <p className="mb-0 fw-bolder fs-7">
                        {chair.event_seat?.seat?.row?.section?.name}
                      </p>
                    </div>
                    <div className="col px-0 text-center">
                      <p className="mb-0">ردیف</p>
                      <p className="mb-0 fw-bolder fs-7">
                        {chair.event_seat?.seat?.row.number}
                      </p>
                    </div>
                    <div className="col-auto px-3 text-center">
                      <p className="mb-0">صندلی</p>
                      <p className="mb-0 fw-bolder fs-7">
                        {chair.event_seat?.seat?.number}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="p-2 fs-8 space-pre">
              حتما ميبايست مشخصات يکي ازهمراهان، با مشخصات روي بليت، يکسان باشد.
              ستاد اجرايي، در صورت لزوم، با کنترل کارت شناسايي و شماره موبايل
              چاپ شده بر روي بليت، از ورود افراديکه بليت را غير از سايت
              irana.app تهيه نمايند، جلوگيري مي کند. بليت فروخته شده به هيچ وجه
              پس گرفته و يا تعويض نميشود. ورود به لابي از 30 دقيقه قبل، آغاز
              خواهد شد و بعد از شروع برنامه، از ورود شما جلوگيري خواهد شد و بليت
              از درجه اعتبار ساقط خواهد بود. آوردن هر گونه تنقلات و نوشيدني به
              داخل سالن ممنوع است. عکاسي و فيلمبرداري، ممنوع بوده و در صورت
              مشاهده، وسايل ضبط و محتواي آن کنترل و پاک ميشود. رعايت حجاب اسلامي
              الزامي مي باشد. داخل سالن استعمال دخانيات ممنوع مي باشد. در صورت
              کنسل شدن برنامه به هر دليلي، حداکثر تا يک هفته کاري، مبالغ عودت
              داده مي شود. از ورود اطفال زير هشت سال، جدا ممانعت بعمل خواهد آمد.
              <span className="d-block">
                رعایت مقررات، پروتکل‌های بهداشتی، تزریق واکسن و استفاده از ماسک
                ضروری می‌باشد
              </span>
            </div>
            <div className="col-12 px-0 align-self-center">
              {/* <span className="mb-0 fs-7">{concert.address}</span>{" "} */}
              <span className="mb-0 fs-7 me-1">
                تلفن پشتیبانی: <a href={`tel:+989146903421`}>09146903421</a>
              </span>
            </div>
          </div>
        </>
      ) : (
        <div className="mt-4 text-center">
          <Spinner animation="border" size="md" />
        </div>
      )}
    </div>
  );
}
